import { useState, useEffect } from 'react';
import {useTranslation} from "react-i18next";
import useMetaTags from 'react-metatags-hook';
import AdvertiseBlock from "../../components/AdvertiseBlock";
import AlphabetFilter from '../../components/AlphabetFilter';

import '../../assets/styles/organizations/organizationsList.scss';
import OrganizationListItem from "./ListItem";
import {sortByAlphabet} from "../../services/aphabet";
import ChunkInfiniteScroll from "../../components/InfiniteScroll/ChunkInfiniteScroll";
import Select from 'react-select';
import trackPageView from "../../services/trackPageView";

export default function OrganizationsList () {
    const { t } = useTranslation();
    const chunkSize = 16;
    useMetaTags({
        title: t('organizations.title'),
        description: t('app.description'),
        metas: [
            { name: 'keywords', content: t('app.keywords') }
        ],
    });
    useEffect(() => {
        trackPageView(t('organizations.title'));
    })
    const [organizationsData, setOrganizationsData] = useState({
        organizations: [],
        categories: [{value: 0, label: t('organizations.all')}],
        currentPage: 1
    });
    const [filter, setFilter] = useState({
        byLetter: '',
        byType: 0,
    });
    const contentExtractor = (item) => item.name[0].toLowerCase();
    const updateLetterFilter = (value) => {
        setFilter({...filter, byLetter: value});
        setOrganizationsData({...organizationsData, currentPage: 1});
    }
    const incrementPage = () => setOrganizationsData({...organizationsData, currentPage: organizationsData.currentPage + 1});

    useEffect(() => {
        fetch("/api/v1/spa/organizations")
            .then(res => res.json())
            .then(
                (result) => {
                    setOrganizationsData({
                        organizations: sortByAlphabet(result.organizations, o => o.name.toLowerCase()),
                        categories: organizationsData.categories.concat(result.categories.map(item => {
                            return {value: item.id, label: item.name};
                        })),
                        currentPage: 1
                    });
                }
            );
    }, []);
    const organizationsList = organizationsData.organizations.filter(item => {
        return (filter.byLetter === '' || item.name[0].toLowerCase() === filter.byLetter.toLowerCase()) &&
            (filter.byType === 0 || item.organizationType.id === filter.byType);
    }).slice(0, organizationsData.currentPage * chunkSize)

    return (
        <section>
            <div className="container">
                <AdvertiseBlock unitId="organizations1" blockLocation="top" />
                <div className="organizations-list-header flex-center">
                    {  <AlphabetFilter
                        list={organizationsData.organizations}
                        contentExtractor={contentExtractor}
                        notifyChange={updateLetterFilter}
                    /> }
                    <div className="organizations-list-filters">
                        <form>
                            <label>{t('organizations.filterBy')}</label>
                            <div>
                                <Select
                                    classNamePrefix="dropdown"
                                    options={organizationsData.categories}
                                    onChange={(selectedOption) => {
                                        setFilter({...filter, byType: selectedOption.value});
                                        setOrganizationsData({...organizationsData, currentPage: 1})
                                    }}
                                    defaultValue={organizationsData.categories[0]}
                                />
                            </div>
                        </form>
                    </div>
                </div>
                <div className="organizations-list-grid js-organizations-list">
                    <ChunkInfiniteScroll
                        Component={OrganizationListItem}
                        items={organizationsList}
                        callback={incrementPage}
                        cancel={organizationsList.length < organizationsData.currentPage * chunkSize}
                    />
                </div>
            </div>
        </section>
    )
}
